import React, { useState } from 'react';
import OrderProductsCard from './OrderProductsCard';

/**
 * Picking tab.
 *
 * Only reachable for orders that carry lines: an order uploaded by spreadsheet
 * has none, and the tab is not rendered for it.
 */
const OrderProductsTab = ({ order }) => {
  const [error, setError] = useState('');

  return (
    <div className="space-y-6 animate-in slide-in-from-bottom-2 duration-300">
      {error && (
        <div className="bg-red-50 dark:bg-red-900/20 text-danger px-5 py-3 rounded-2xl border border-red-200 dark:border-red-900 text-sm font-medium flex items-center justify-between gap-4">
          <span>{error}</span>
          <button onClick={() => setError('')} className="font-bold shrink-0">Cerrar</button>
        </div>
      )}

      <OrderProductsCard order={order} onError={setError} />
    </div>
  );
};

export default OrderProductsTab;
